import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAnalytics } from '../../../contexts';
import { FetchStatus } from '../../../enums';
import { useOrganization } from '../../../features/organization';
import { getPatientSyncState, usePatients, useTableHeaders, useTableRows } from '../../../features/patients';
import { Card } from '../../common';
import { Table } from '../table';
import { NoPatients, PatientsHeader } from './components';

export const Patients = () => {
  const navigate = useNavigate();
  const { patients, status } = usePatients();
  const { organization } = useOrganization();
  const analytics = useAnalytics();
  const patientRows = useTableRows();
  const header = useTableHeaders();
  const loaded = useMemo(() => [FetchStatus.SUCCESS, FetchStatus.FAILURE].includes(status), [status]);

  const navigateToPatient = (id: string | number) => {
    const patient = patients.find((p) => p.id === id);
    if (patient && organization) {
      analytics.track('View patient', {
        patientId: patient.id,
        organization: organization.name,
        status: getPatientSyncState(patient),
        aktiiaStatus: patient.bloodPressure.status,
      });
    }
    navigate(`/app/patients/${id}`);
  };

  return (
    <Card>
      <PatientsHeader />

      {loaded && !patientRows.length ? (
        <NoPatients />
      ) : (
        <Table rows={patientRows} header={header} onRowClick={navigateToPatient} loading={!loaded} />
      )}
    </Card>
  );
};
